import { render } from "./pieChart.vue?vue&type=template&id=362beb5c&scoped=true"
import script from "./pieChart.vue?vue&type=script&lang=js"
export * from "./pieChart.vue?vue&type=script&lang=js"

import "./pieChart.vue?vue&type=style&index=0&id=362beb5c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362beb5c"]])

export default __exports__